<template>
    <div id="swiper-wrapper">

    <Row class="swiper_row">
        <Col span="0.5">
          <div class="success-left-div" @click="prevBtn">
            <img src="../assets/img/success-left.png" width="50%">
          </div>
        </Col>
        <Col>
          <div>
            <swiper ref="mySwiper" :options="swiperOption">
              <swiper-slide class="recommend-item" v-for="item of recommends" :key="item.goodsId">
                <div class="carousel-content">
                  <div class="content-a" :style="item.goodsName==''?'opacity:0':''">
                      <img :src="item.image" :style="item.image==''?'opacity:0':''"  width="40%"/>
                      <h4>{{item.goodsName}}</h4>
                      <p>{{item.goodsContent}}</p>
                      <router-link :to="{path:'successDetails',query:{num:item.goodsId}}">
                        <p class="success-p">{{item.more}}</p>
                      </router-link>
                  </div>
                </div>
              </swiper-slide>

            </swiper>
          </div>
        </Col>
      <Col span="0.5">
          <div class="success-right-div">
            <img src="../assets/img/success-right.png" @click="nextBtn" width="50%">
          </div>
        </Col>
      </Row>

  </div>
</template>

<script>
   import { Icon } from 'vant';
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css';
  export default {
    components: {
      [Icon.name]: Icon,
      Swiper,
      SwiperSlide,
    },
    props: {
    },
    data() {
      return {
        swiperOption: {
          slidesPerView: 3,
          autoplay: false,
          navigation: {
                   nextEl: '.swiper-button-next',
                   prevEl: '.swiper-button-prev',
                 }
        },
        recommends: [
          {
            goodsId:4,
            image:require("../assets/img/xl.png"),
            goodsName:"宜昌市西陵区文体通",
            goodsContent:"对全区文体资源进行线上统一整合，同时加强疫情期间全区文体业从业人员、游客管控。方便市民通过手机...",
            more:"MORE>>"
          },
          {
            goodsId:5,
            image:require("../assets/img/gaj.png"),
            goodsName:"某市公安局大数据平台",
            goodsContent:"按照市县两级大数据指挥服务中心、派出所勤务指挥室及各专业警种大数据可视化建设需求,利用全市各类公安业务...",
            more:"MORE>>"
          },
          {
            goodsId:6,
            image:"",
            goodsName:"枣阳市政务外网整体改造升级项目",
            goodsContent:"按照襄阳市已批复的政务外网技术方案要求，在现有政务基础设施网络基础上，升级改造电子政务外网，构建起连接全市...",
            more:"MORE>>"
          },
		  {
		    goodsId:10,
		    image:"",
		    goodsName:"北京冬奥会",
		    goodsContent:"同步保障首次冬奥赛事8K超高清直播，四大国家级运动场馆都对视频系统进行了新建或改造升级，利亚德则为四大场馆提供...",
		    more:"MORE>>"
		  },
			{
			  goodsId:11,
			  image:"",
			  goodsName:"第七届世界军人运动会闭幕式总制作",
			  goodsContent:"“小间距”可谓是利亚德集团的杀手锏之一,LED显示屏的小间距，也就是每一个小灯珠的间距，利亚德已经达到世界上最领先的0.6mm...",
			  more:"MORE>>"
			},
			{
			  goodsId:12,
			  image:"",
			  goodsName:"献礼新中国成立70周年",
			  goodsContent:"为庆祝新中国成立70周年，利亚德为庆典活动提供了1.4万平方米的多种类显示产品及显示系统。除为晚会表演现场提供特效支持外...",
			  more:"MORE>>"
			}
        ]
      }
    },
    methods:{
      prevBtn() {
        this.$refs.mySwiper.$swiper.slidePrev();
      },
      nextBtn() {
         this.$refs.mySwiper.$swiper.slideNext();
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  .ddd{
    width: 40px;
  }
  .ccc{
    width: 40px;
  }
#swiper-wrapper{
  position: relative;
}
  .success-left-div {
    // padding-top: 1rem;
    position: absolute;
    left: 0;
    top: 50%;
    width: 35px;
    margin-top: -18.8px;
     z-index: 15;
      cursor: pointer;
  }
  .success-right-div{
    position: absolute;
    right: -18px;
    top: 50%;
    width: 35px;
    margin-top: -18.8px;
    z-index: 15;
    cursor: pointer;
    img{
      // margin-left: 100%;
    }
  }
  .carousel-content{
    text-align: center;
    padding: 0 7%;
    .content-a{
 	background-image: linear-gradient(0deg,
		#fdfdfd 50%,
		#f4f5fa 100%);
      height: 3.2rem;
      img{
        margin-top: 0.4rem;
        // height: 0.4rem;
        height: 23.9px;
        margin-bottom: 0.2rem;
      }
      h4{
        	font-family: SourceHanSansCN-Medium;
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #253954;
	overflow:hidden; //超出的文本隐藏
	text-overflow:ellipsis; //溢出用省略号显示
	white-space:nowrap; //溢出不换行
      }
      p{
        margin-top: 0.2rem;
        padding: 0 0.2rem;
        text-align: left;

        	font-family: SourceHanSansCN-Medium;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #253954;
  font-size: 12px;
	height: 70px;
      }
      .success-p{
        text-align: right;
        color: #5ac1ff;
        cursor: pointer;
      }
    }
  }
  .ivu-tabs-nav-prev{
    top: 12px;
     color: #5ac1ff;
  }
  .ivu-tabs-nav-next{
    top: 12px;
        color: #5ac1ff;
  }
</style>



// WEBPACK FOOTER //
// src/util/SuccessEnterprise.vue